import type { FC, ReactNode } from "react";

import { ListCard } from "@/components/ui/list-card";
import { SectionHeader } from "@/components/ui/page-header";

/** A client Settings section: the title (and a sentence) above one list card. */
export const SettingsSection: FC<{
  title: string;
  description?: ReactNode;
  children: ReactNode;
}> = ({ title, description, children }) => (
  <section className="flex flex-col gap-3">
    <SectionHeader title={title} description={description} />
    <ListCard>{children}</ListCard>
  </section>
);

/** A label-left row inside a settings card: 176px label, then the control. */
export const SettingsFieldRow: FC<{
  label: ReactNode;
  htmlFor?: string;
  hint?: ReactNode;
  children: ReactNode;
}> = ({ label, htmlFor, hint, children }) => (
  <div className="grid gap-x-4 gap-y-1.5 px-4 py-2.5 sm:grid-cols-[176px_minmax(0,1fr)]">
    <label htmlFor={htmlFor} className="pt-1.5 text-base text-fg-2">
      {label}
    </label>
    <div className="flex min-w-0 flex-col gap-1.5">
      {children}
      {hint ? <span className="text-sm text-fg-3">{hint}</span> : null}
    </div>
  </div>
);
